module.exports = __webpack_public_path__ + "80305bdfdefdf17852e3d06fcdda43f3.pdf";